import axios from "../config/axios";
import Constants from "../data/Constants";

export const getUserList = async (filters, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.USER.ALL, { params: filters })
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleUser = async (id) => {
  return await axios.get(Constants.ENDPOINTS.USER.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const getSingleStudent = async (id) => {
  return await axios
    .get(Constants.ENDPOINTS.STUDENT.SINGLE + id)
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleMentor = async (id, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.MENTOR.SINGLE2 + id)
    .then((res) => {
      return res.data.result;
    });
};

export const deactivateMentee = async (id, pagination = {}) => {
  return await axios
    .post(Constants.ENDPOINTS.USER.DEACTIVATE + id)
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleMentor2 = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MENTOR.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const createSingleMentor = async (data, pagination = {}) => {
  const formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .post(Constants.ENDPOINTS.MENTOR.CREATE_SINGLE, formData, config)
    .then((res) => {
      return res.data.result;
    });
};

export const updateSingleMentor = async (id, data, pagination = {}) => {
  const formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .post(Constants.ENDPOINTS.MENTOR.UPDATE_SINGLE + id, formData, config)
    .then((res) => {
      return res.data.result;
    });
};
